import React from 'react';
import '../../VendorStyles/AddCouponForm.css';
import CloseIcon from '../../assets/svg/closeIcon';
import { 
    TextField, Checkbox, FormControlLabel, Select, MenuItem, Button
} from '@mui/material';

function AddCouponForm({
    handleClose,
    description,
    shortDescription,
    title,
    validFrom,
    validTo,
    setValidTo,
    couponCode,
    setCouponCode,
    autoGenerateCode,
    handleAddOrUpdateCoupon,
    handleAutoGenerateCodeChange,
    isEditing,
    status,
    setStatus,
    noBoundaries,
    setNoBoundaries,
    maxAmount,
    redeemLimit,
    titleError,
    descriptionError,
    shortDescriptionError,
    redeemLimitError,
    maxAmountError,
    handleTitleChange,
    handleDescriptionChange,
    handleShortDescriptionChange,
    handleRedeemLimit,
    handleMaxAmount,
    handleValidFromChange,
    validFromError,
    validToError,
    couponError,
}) {

    const getCurrentDateTime = () => {
        const now = new Date();
        const offset = now.getTimezoneOffset();
        const localDate = new Date(now.getTime() - offset * 60000);
        return localDate.toISOString().slice(0, 16);
    };

    const currentDateTime = getCurrentDateTime();


    return (
        <div className="popup-container">
            <div className='coupen-offer-heading'>
                <h2 className='coupen-offer-heading-text'>{isEditing ? 'Edit Coupon' : 'Add Coupon'}</h2>
                <CloseIcon
                    onClick={handleClose}
                    className='close-icon'
                />
            </div>
            <div className="coupon-form-container">
                <div className="coupon-form-group">
                    <div className="add-coupon-offer-field-txt">Title :</div>
                    <TextField 
                        fullWidth 
                        size="small" 
                        value={title} 
                        onChange={handleTitleChange} 
                        error={!!titleError} 
                        helperText={titleError} 
                        placeholder='Enter coupon title'
                    />
                </div>
                <div className="coupon-form-group">
                    <div className="add-coupon-offer-field-txt">Description :</div>
                    <TextField 
                        fullWidth 
                        size="small" 
                        value={description} 
                        onChange={handleDescriptionChange} 
                        error={!!descriptionError} 
                        helperText={descriptionError}
                        placeholder='Enter detailed description' 
                    />
                </div>
                <div className="coupon-form-group">
                    <div className="add-coupon-offer-field-txt">Short Description :</div>
                    <TextField 
                        fullWidth 
                        size="small" 
                        value={shortDescription} 
                        onChange={handleShortDescriptionChange} 
                        error={!!shortDescriptionError} 
                        helperText={shortDescriptionError} 
                        placeholder='Enter short description'
                    />
                </div>
                <div className="coupon-form-group">
                    <div className="add-coupon-offer-field-txt">Discount Amount :</div>
                    <TextField 
                        fullWidth 
                        size="small" 
                        value={maxAmount} 
                        onChange={handleMaxAmount} 
                        inputProps={{ maxLength: 3 }} 
                        error={!!maxAmountError} 
                        helperText={maxAmountError} 
                        placeholder='Enter discount amount'
                    />
                </div>
                <div className="coupon-form-group">
                    <div className="add-coupon-offer-field-txt">Redeem Limit :</div>
                    <TextField 
                        fullWidth 
                        size="small" 
                        value={redeemLimit} 
                        onChange={handleRedeemLimit} 
                        inputProps={{ maxLength: 5 }} 
                        error={!!redeemLimitError} 
                        helperText={redeemLimitError} 
                        placeholder="Enter redeem limit"
                    />
                </div>
                <div className="generate-coupon-code">
                    <FormControlLabel
                        control={
                            <Checkbox 
                                checked={autoGenerateCode} 
                                onChange={handleAutoGenerateCodeChange} 
                            />
                        }
                        label="Auto-generate Coupon Code"
                    />
                </div>
                <div className="coupon-form-group">
                    <div className="add-coupon-offer-field-txt">Coupon Code :</div>
                    <TextField 
                        fullWidth 
                        size="small" 
                        value={couponCode} 
                        onChange={(e) => setCouponCode(e.target.value)} 
                        error={!!couponError} 
                        helperText={couponError} 
                        required 
                        placeholder="Enter or generate coupon code"
                    />
                </div>
                <div className="no-boundries-label-and-checkbox">
                    <FormControlLabel
                        control={
                            <Checkbox 
                                checked={noBoundaries} 
                                onChange={(e) => setNoBoundaries(e.target.checked)} 
                            />
                        }
                        label="No Boundaries"
                    />
                </div>
                {!noBoundaries && (
                    <>
                        <div className="coupon-form-group">
                            <div className="add-coupon-offer-field-txt">Validity From :</div>
                            <TextField 
                                type="datetime-local" 
                                fullWidth 
                                size="small" 
                                value={validFrom} 
                                onChange={handleValidFromChange} 
                                error={!!validFromError} 
                                helperText={validFromError} 
                                inputProps={{ min: currentDateTime }}
                                placeholder="Select start date and time"
                            />
                        </div>
                        <div className="coupon-form-group">
                            <div className="add-coupon-offer-field-txt">Validity To :</div>
                            <TextField 
                                type="datetime-local" 
                                fullWidth 
                                size="small" 
                                value={validTo} 
                                onChange={(e) => setValidTo(e.target.value)} 
                                inputProps={{ min: validFrom || currentDateTime }}
                                error={!!validToError} 
                                helperText={validToError} 
                                placeholder="Select end date and time"
                            />
                        </div>
                    </>
                )}
                {isEditing && (
                    <div className="coupon-form-group">
                        <div className="add-coupon-offer-field-txt">Status:</div>
                        <Select 
                            value={status} 
                            onChange={(e) => setStatus(e.target.value)} 
                            size="small" 
                            style={{ width: '100px' }} 
                        >
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Deactive">Deactive</MenuItem>
                        </Select>
                    </div>
                )}
            </div>
            <div className="vendor-coupon-offer-button">
                <Button 
                    variant="contained"
                    onClick={handleAddOrUpdateCoupon} 
                    style={{ minWidth: '100px',backgroundColor: '#e13535' }}
                >
                    {isEditing ? 'Update' : 'Add'}
                </Button>
            </div>
        </div>
    );
}

export default AddCouponForm;